<template>
  <div id="app">
    <div id="mainSidebar" class="page-wrapper sidebar" :class="{toggled: isActive}">
      <Quicksearch />
      <Nav ref="nav" />
      <Map ref="map" />
      <AppLoading v-if="true" />
    </div>
  </div>
</template>

<script>
import Quicksearch from "./components/Quicksearch.vue";
import Nav from "./components/Nav.vue";
import Map from "./components/Map.vue";
import AppLoading from "./components/AppLoading";

export default {
  name: "app",
  data() {
    return {
      isActive: true
    };
  },
  components: {
    Quicksearch,
    Nav,
    Map,
    AppLoading
  },
  mounted: function() {
    this.$root.$on("toggle", isActive => {
      this.isActive = isActive;
    });
  }
};
</script>
